<template>
  <v-flex xs12 row>
  	<v-layout row wrap>
  		<v-flex xs12>
  			
  		</v-flex>
  	</v-layout>

	<v-layout py-3>
   		<v-flex xs12 sm8 offset-sm2>
   			<v-card>
	   			<v-card-title>
	   				<autocomplete v-model="filter.retailer_id" :items="retailers" label="Branch" />
	   				<autocomplete v-model="filter.brand_id" :items="brands" label="Brand" />

		          	<search-btn @click="filterData" />

			      <v-spacer></v-spacer>
			      
			      <v-dialog v-model="dialog" max-width="600px">
			        <v-card>
			          <v-card-title>
			            <span class="headline">Update Access</span>
			          </v-card-title>

			          <v-card-text>
			            <v-container grid-list-md py-0>
			              <v-layout wrap>
			                <v-flex xs12 sm6>
			                  <v-text-field readonly v-model="item.brand_name" label="Brand"></v-text-field>
			                </v-flex>
			                <v-flex xs12 sm6>
			                  <v-text-field readonly v-model="item.retailer_name" label="Branch"></v-text-field>
			                </v-flex>
			                <v-flex xs12 sm6>
			                  <v-checkbox label="Brand Access" v-model="item.has_access"></v-checkbox>
			                </v-flex>
			              </v-layout>
			            </v-container>
			          </v-card-text>

			          <v-card-actions>
			            <v-spacer></v-spacer>
			            <v-btn color="blue darken-1" flat @click.native="close">Cancel</v-btn>
			            <v-btn color="blue darken-1" flat @click.native="updateItem">Update</v-btn>
			          </v-card-actions>
			        </v-card>
			      </v-dialog>

			    </v-card-title>
	   			<v-data-table
				    :headers="headers"
				    :loading="processing"
				    :items.sync="brandAccesses"
				    v-model="selected"
				    item-key="id"
      				hide-actions
				  >
				  	<v-progress-linear slot="progress" color="blue" indeterminate></v-progress-linear>
				    <template slot="headerCell" slot-scope="props">
				      <v-tooltip bottom>
				        <span slot="activator">
				          {{ props.header.text }}
				        </span>
				        <span>
				          {{ props.header.text }}
				        </span>
				      </v-tooltip>
				    </template>
				    <template slot="items" slot-scope="props">
				      <td>{{ props.item.retailer_name }}</td>
				      <td>{{ props.item.brand_name }}</td>
				      <td>
				      	<v-icon small :color="props.item.has_access ? 'success' : 'error'" v-text="props.item.has_access ? 'done' : 'clear'"></v-icon>
				      </td>
				      <td class="align-center justify-center">
				      	<v-icon small class="mr-1" @click="editItem(props.item)" v-if="props.item.is_editable && hasEditAccess">edit</v-icon>
				      </td>
				    </template>
				    <template slot="no-data" v-if="!processing">
				      <v-alert :value="true" color="error" icon="warning">
				        Sorry, nothing to display here :(
				      </v-alert>
				    </template>
				  </v-data-table>

				  <v-pagination @loadPage="loadPage" />
				  
			</v-card>
   		</v-flex>
   	</v-layout>
    
  </v-flex>
</template>

<script>

  export default {
    name: 'BrandAccesses',
    data () {
      return {
      	title: "View Brand Accesses",
      	processing: false,
      	brandAccesses: [],
        selected: [],
        headers: [
          { text: 'Branch', value: 'retailer_name'},
          { text: 'Brand', value: 'brand_name' },
          { text: 'Access', value: 'has_access', sortable: false },
          { text: 'Actions', value: 'id', sortable: false }
        ],
        item: {},
        dialog: false,
        filter: {
          retailer_id: "",
          brand_id: ""
        },
        brands: [{id: "", title: "All"}],
        retailers: [{id: "", title: "All"}]
      }
    },
    methods: {

    	loadPage () {

    		let api_path = this.config.apis.viewBrandAccesses.replace(":page", this.currentPage).replace(":perPage", this.paginationOptions.rowsPerPage)
	        
	        let filterArray = []

	        for (const [key, val] of Object.entries(this.filter)) {
	          filterArray.push(`${key}=${val}`)
	        }

	        api_path += '?' + filterArray.join('&')

    		this.processing = true
	        this.axios.get(api_path)
	          .then((response) => {
	            this.processing = false
	            if (this.isSuccessResponse(response)) {
	            	
	            	this.$store.commit('setItemsCount', response.data.data.total)
	            	
	            	this.brandAccesses = response.data.data.items
	            }
	            else{
	            	this.brandAccesses = []
	            	this.$store.commit('setItemsCount', 0)
	            }
	          })
	          .catch((error) => {
	            this.processing = false
	          })
    	},

		updateItem: function(){
			this.processing = true
			this.axios.put(this.config.apis.updateBrandAccess.replace(":id", this.item.id), this.item)
			  .then((response) => {
			    if (this.isSuccessResponse(response)) {
	              this.notifySuccess('updateSuccess')
	              this.close()
	            }
	            else{
	              this.notifyError('updateError')
	            }
	            this.processing = false
			  })
			  .catch((error) => {
			    this.processing = false
			  })
		},

      	close () {
        	this.dialog = false
        	setTimeout(() => {
          		this.item = {}
        	}, 300)
      	},

      	editItem (item) {
	        this.item = item
	        this.dialog = true
	    }

    },
    created () {
    	let breadcrumbs = [
	      	{
	          text: 'Dashboard',
	          disabled: false,
	          href: '/dashboard'
	        },
	        {
	          text: 'Brands',
	          disabled: false,
	          href: '/brands'
	        },
	        {
	          text: 'Brand Access',
	          disabled: true
	        }
       ]

       this.$store.commit('setBreadcrumbs', breadcrumbs)
       this.$store.commit('setPageTitle', 'Manage Brand Access')
    },
    mounted () {

    	this.getAllData('retailer')
	        .then((response) => {
	          this.retailers = this.retailers.concat(response)
	        })

	    this.getAllData('brand')
	        .then((response) => {
	          this.brands = this.brands.concat(response)
	        })
    },

    computed: {

    }

  }
</script>
